import * as utils from '../../utils'
import CONSTANTS from '../../constants/index'
import Vue from 'vue'

const EMPTY_QUOTEINFO = {
  accidentList: null,
  applicant: {},
  base: {},
  carModelInfos: null,
  deliveryInfo: null,
  insured: {},
  lastPolicyInfoDtoList: null,
  noCarRiskList: null,
  orderNo: null,
  owner: {},
  premiumNoteContent: null,
  reInsureList: null,
  riskList: [],
  underwriteResultList: null,
  vehicle: {},
  violationList: [],
}

const getters = {
  getSyInfo() {
    // TODO 根据新能源标志切换新能源0317、商业险0312险种信息
    let syInfo = {}
    if (
      state.switchList.new_energy_vehicles_switch == '1' &&
      state.quoteInfo.vehicle.newEnergyFlag == '1' &&
      state.quoteInfo.base.insuredProduct == '3'
    ) {
      syInfo.coverage_list = CONSTANTS.COVERAGE_List_XNY
      syInfo.sy_risk = CONSTANTS.XNY_RISK
      syInfo.risk_limits_link = CONSTANTS.RISK_LIMITS_LINK_XNY
      syInfo.cs_fjins = CONSTANTS.CS_FJINS_XNY
      syInfo.sy_risk_code = CONSTANTS.XNY_RISK_CODE
    } else {
      syInfo.coverage_list = CONSTANTS.COVERAGE_List
      syInfo.sy_risk = CONSTANTS.SY_RISK
      syInfo.risk_limits_link = CONSTANTS.RISK_LIMITS_LINK
      syInfo.cs_fjins = CONSTANTS.CS_FJINS
      syInfo.sy_risk_code = CONSTANTS.SY_RISK_CODE
    }
    return syInfo
  },
  getChargingPileList(state) {
    // 获取store的充电桩数据
    let sy_code =
      state.switchList.new_energy_vehicles_switch == '1' &&
      state.quoteInfo.vehicle.newEnergyFlag == '1' &&
      state.quoteInfo.base.insuredProduct == '3'
        ? CONSTANTS.XNY_RISK_CODE
        : CONSTANTS.SY_RISK_CODE
    return (
      state.quoteInfo.riskList.find((item) => item.riskCode == sy_code) || {}
    ).chargingPileList
  },
  getNewEnergyFlag(state) {
    // TODO 获取新能源状态
    return (
      state.switchList.new_energy_vehicles_switch == '1' &&
      state.quoteInfo.vehicle.newEnergyFlag == '1' &&
      state.quoteInfo.base.insuredProduct == '3'
    )
  },
  getWunina(state) {
    return state.wunian
  },
  getSyRisk(state) {
    // TODO 新能源
    let sy_code =
      state.switchList.new_energy_vehicles_switch == '1' &&
      state.quoteInfo.vehicle.newEnergyFlag == '1' &&
      state.quoteInfo.base.insuredProduct == '3'
        ? CONSTANTS.XNY_RISK_CODE
        : CONSTANTS.SY_RISK_CODE
    return state.quoteInfo.riskList.find((item) => item.riskCode == sy_code)
  },
  getJqRisk(state) {
    return state.quoteInfo.riskList.find(
      (item) => item.riskCode == CONSTANTS.JQ_RISK_CODE
    )
  },
  getSwitchList(state) {
    return state.switchList
  },
  getIsDigital(state) {
    return state.isDigital
  },
  getBuyedInfo(state) {
    let risk = state.quoteInfo.riskList
    let isSY = false
    let isJQ = false
    let syInstruction = []
    let jqInstruction = []
    risk.forEach((item) => {
      if (item.riskCode === '0301') {
        //'交强险',
        isJQ = true
        item.clauseList &&
          item.clauseList.forEach((list) => {
            jqInstruction.push(list.clauseContext)
          })
      }
      let sy_code =
        state.switchList.new_energy_vehicles_switch == '1' &&
        state.quoteInfo.vehicle.newEnergyFlag == '1' &&
        state.quoteInfo.base.insuredProduct == '3'
          ? CONSTANTS.XNY_RISK_CODE
          : CONSTANTS.SY_RISK_CODE
      if (item.riskCode === sy_code) {
        //'商业险',
        isSY = true
        item.clauseList &&
          item.clauseList.forEach((list) => {
            syInstruction.push(list.clauseContext)
          })
      }
    })
    return { isSY, isJQ, jqInstruction, syInstruction }
  },
  // 获取特约信息
  getClauseList(state) {
    let clauseList = []
    state.quoteInfo.riskList.forEach((risk) => {
      if (risk.clauseList) {
        risk.clauseList.forEach((clause) => {
          if (clause.isNeeded == 1) {
            clauseList.push(clause)
          }
        })
      }
      if (risk.coreClauseList) {
        risk.coreClauseList.forEach((clause) => {
          if (clause.isNeeded == 1) {
            clauseList.push(clause)
          }
        })
      }
    })
    return clauseList
  },
}

const mutations = {
  setPopFrameInfo(state, popFrameInfo) {
    state.popFrameInfo = popFrameInfo
  },
  setBaseAddress(state, address) {
    state.baseAddress = address
  },
  clearCacheRecordInfo(state) {
    const data = {
      owner: {
        name: '',
        identifyNumber: '',
        identifyExpiry: '',
        birthday: '',
        justSrc: '',
        justName: '',
        backName: '',
        backSrc: ''
      },
      insured: {
        name: '',
        identifyNumber: '',
        identifyExpiry: '',
        birthday: '',
        justSrc: '',
        justName: '',
        backName: '',
        backSrc: ''
      },
      applicant: {
        name: '',
        identifyNumber: '',
        identifyExpiry: '',
        birthday: '',
        justSrc: '',
        justName: '',
        backName: '',
        backSrc: ''
      },
      vehicle: {
        licenseNo: '',
        brandName: '',
        frameNo: '',
        singeinDate: '',
        engineNo: '',
        justSrc: '',
        justName: '',
        backName: '',
        backSrc: ''
      },
    }
    Vue.set(state, 'cacheRecordInfo', data)
  },
  setCacheRecordInfo(state, cacheRecordInfo) {
    Vue.set(state, 'cacheRecordInfo', cacheRecordInfo)
  },
  setOtaVehicle(state, otaVehicle) {
    let _otaVehicle = Object.assign(state.quoteInfo.vehicle, otaVehicle)
    Vue.set(state.quoteInfo, 'vehicle', _otaVehicle)
  },
  setChargingPileList(state, _chargingPileList) {
    let sy_code =
      state.switchList.new_energy_vehicles_switch == '1' &&
      state.quoteInfo.vehicle.newEnergyFlag == '1' &&
      state.quoteInfo.base.insuredProduct == '3'
        ? CONSTANTS.XNY_RISK_CODE
        : CONSTANTS.SY_RISK_CODE
    if (state.quoteInfo.riskList) {
      for (let index = 0; index < state.quoteInfo.riskList.length; index++) {
        let risk = state.quoteInfo.riskList[index]
        if (sy_code == risk.riskCode) {
          Vue.set(
            state.quoteInfo.riskList[index],
            'chargingPileList',
            _chargingPileList
          )
          break
        }
      }
    }
  },
  setQuoteInfo(state, quoteInfo) {
    let address = state.quoteInfo.applicant.address,
      invtype = state.quoteInfo.applicant.invtype,
      mobilePhone = state.quoteInfo.applicant.mobilePhone,
      name = state.quoteInfo.applicant.name,
      shanghai = state.quoteInfo.shanghai,
      beijing = state.quoteInfo.beijing
    // email = state.quoteInfo.applicant.email;
    if (quoteInfo.riskList == null) {
      quoteInfo.riskList = []
    }
    let newQuoteInfo = utils.mergeCarBeans(
      utils.deepClone(CONSTANTS.CAR_BEANS),
      quoteInfo
    )
    Vue.set(state, 'quoteInfo', newQuoteInfo)
    Vue.set(state.quoteInfo.applicant, 'invtype', invtype)
    // 投被保人地址不存在, 就设置成配送地址
    Vue.set(state.quoteInfo.applicant, 'address', quoteInfo.applicant.address || address)
    Vue.set(state.quoteInfo.insured, 'address', quoteInfo.insured.address || address)
    Vue.set(state.quoteInfo.applicant, 'mobilePhone', mobilePhone)
    Vue.set(state.quoteInfo.applicant, 'name', quoteInfo.applicant.name || name)
    // Vue.set(state.quoteInfo.applicant, 'email', email);
    Vue.set(state.quoteInfo, 'shanghai', shanghai)
    Vue.set(state.quoteInfo, 'beijing', beijing)
  },
  setSdQuoteInfo(state, sdQuoteInfo) {
    state.sdQuoteInfo = sdQuoteInfo
  },
  setInitQuoteInfo(state, initQuoteInfo) {
    if (initQuoteInfo.riskList == null) {
      initQuoteInfo.riskList = []
    }
    Vue.set(state, 'initQuoteInfo', initQuoteInfo)
    Vue.set(state, 'quoteInfo', initQuoteInfo)
  },
  clearRiskList(state) {
    Vue.set(state.quoteInfo, 'riskList', [])
  },
  setRiskList(state, riskList) {
    Vue.set(state.quoteInfo, 'riskList', riskList)
  },
  setSwitchList(state, switchList) {
    Vue.set(state, 'switchList', switchList)
    Vue.set(state, 'useNaturesSubSwitch', switchList.useNaturesSubSwitch.indexOf(state.quoteInfo.base.companyCode.substring(0, 4)) > -1)
  },
  setIsDigital(state, isDigital) {
    Vue.set(state, 'isDigital', isDigital)
  },
  // 重设商业险保额
  setSyRiskListDefauleInsured(state) {
    //Vue.set(state.quoteInfo, 'riskList', riskList);
    // TODO 新能源
    let sy_code
    let coverrage_object
    if (
      state.switchList.new_energy_vehicles_switch == '1' &&
      state.quoteInfo.vehicle.newEnergyFlag == '1' &&
      state.quoteInfo.base.insuredProduct == '3'
    ) {
      sy_code = CONSTANTS.XNY_RISK_CODE
      coverrage_object = CONSTANTS.COVERAGE_OBJECT_XNY
    } else {
      sy_code = CONSTANTS.SY_RISK_CODE
      coverrage_object = CONSTANTS.COVERAGE_OBJECT
    }
    state.quoteInfo.riskList.forEach((risk, index) => {
      if (sy_code == risk.riskCode) {
        let new_COVERAGE_List = []
        risk.coverageList.forEach((coverageItem) => {
          new_COVERAGE_List.push(coverrage_object[coverageItem.kindCode])
        })
        Vue.set(
          state.quoteInfo.riskList[index],
          'coverageList',
          new_COVERAGE_List
        )
      }
    })
  },
  // 电子保单标志
  setPolicyStyles(state, policyStyles) {
    Vue.set(state.quoteInfo.base.busiAttrConfig, 'policyStyles', policyStyles)
    switch (policyStyles) {
      case '0':
        // 覆盖base节点下policyStyles 并传值''
        Vue.set(state, 'electronicPolicyFlag', false)
        break
      case '1':
        // 电子保单 覆盖base节点下覆盖base节点下policyStyles
        Vue.set(state, 'electronicPolicyFlag', false)
        break
      case '2':
        // 保存华安电子保单标志
        Vue.set(state, 'electronicPolicyFlag', true)
        break
    }
  },
  // 车船税 税务信息
  setTaxRelief(state, taxReliefInfo) {
    taxReliefInfo.taxPayerName = state.quoteInfo.owner.name
    let newTaxReliefInfo = taxReliefInfo
    if (state.quoteInfo.riskList) {
      state.quoteInfo.riskList.forEach((risk, index) => {
        if (CONSTANTS.JQ_RISK_CODE == risk.riskCode) {
          newTaxReliefInfo = Object.assign(
            {},
            newTaxReliefInfo,
            risk.vhlTax,
            taxReliefInfo
          )
          Vue.set(state.quoteInfo.riskList[index], 'vhlTax', newTaxReliefInfo)
          //state.quoteInfo.riskList[index].vhlTax= Object.assign({},vhlTax,taxReliefInfo);
        }
      })
    }

    Vue.set(
      state,
      'vhlTax',
      Object.assign({}, CONSTANTS.JQ_RISK.vhlTax, newTaxReliefInfo)
    )
  },
  setJqrisk(state, jqRisk) {
    let hasJqrisk = false
    state.quoteInfo.riskList.forEach((risk, index) => {
      if (CONSTANTS.JQ_RISK_CODE == risk.riskCode) {
        let newRisk = Object.assign({}, risk, jqRisk)
        Vue.set(state.quoteInfo.riskList, index, newRisk)
        hasJqrisk = true
      }
    })

    if (!hasJqrisk) {
      state.quoteInfo.riskList.push(jqRisk)
    }
  },
  setSyrisk(state, syRisk) {
    let hasSyrisk = false
    // TODO 新能源
    let sy_code =
      state.switchList.new_energy_vehicles_switch == '1' &&
      state.quoteInfo.vehicle.newEnergyFlag == '1' &&
      state.quoteInfo.base.insuredProduct == '3'
        ? CONSTANTS.XNY_RISK_CODE
        : CONSTANTS.SY_RISK_CODE
    state.quoteInfo.riskList.forEach((risk, index) => {
      if (sy_code == risk.riskCode) {
        let newRisk = Object.assign({}, risk, syRisk)
        Vue.set(state.quoteInfo.riskList, index, newRisk)
        hasSyrisk = true
      }
    })
    if (!hasSyrisk) {
      state.quoteInfo.riskList.push(syRisk)
    }
  },
  // 折旧后重设保额
  setDepreciation(state, depreInfo) {
    Vue.set(state.quoteInfo.vehicle, 'actualValue', depreInfo.actualValue)
    Vue.set(
      state.quoteInfo.vehicle,
      'depreciationRate',
      depreInfo.depreciationRate
    )
  },
  // 存储保费
  setCalPremiumResult(state, result) {
    Vue.set(state, 'calPremiumResult', result)
  },
  // 保存商交标志
  setRiskFlag(state, riskFlag) {
    state.riskFlag = riskFlag
  },
  setPolicyAdress(state, policyAndInvtype) {
    Vue.set(state.quoteInfo.applicant, 'invtype', policyAndInvtype.invtype)
    Vue.set(
      state.quoteInfo.applicant,
      'mobilePhone',
      policyAndInvtype.deliveryInfo.mobilePhone
    )
    Vue.set(
      state.quoteInfo.applicant,
      'name',
      policyAndInvtype.deliveryInfo.name
    )
    Vue.set(state.quoteInfo.applicant, 'email', policyAndInvtype.email)
    // 投被保人地址不存在, 就设置成配送地址
    Vue.set(
      state.quoteInfo.applicant,
      'address',
      policyAndInvtype.deliveryInfo.address
    )
    Vue.set(
      state.quoteInfo.insured,
      'address',
      policyAndInvtype.deliveryInfo.address
    )
  },
  // 保存配送信息
  setPolicyAndInvtype(state, policyAndInvtype) {
    //发票类型 && 手机 && 邮箱
    Vue.set(state.quoteInfo.applicant, 'invtype', policyAndInvtype.invtype)
    Vue.set(
      state.quoteInfo.applicant,
      'mobilePhone',
      policyAndInvtype.deliveryInfo.mobilePhone
    )
    if (state.quoteInfo.applicant.email && policyAndInvtype.email) {
      Vue.set(state.quoteInfo.applicant, 'email', policyAndInvtype.email)
    } //电子发票邮箱 和 投保人邮箱是同一个字段
    // 邮箱
    Vue.set(state.quoteInfo.insured, 'email', policyAndInvtype.email)
    // 配送信息
    Vue.set(state.quoteInfo, 'deliveryInfo', policyAndInvtype.deliveryInfo)
    // 投被保人地址不存在, 就设置成配送地址
    !state.quoteInfo.applicant.address
      ? Vue.set(
          state.quoteInfo.applicant,
          'address',
          policyAndInvtype.deliveryInfo.address
        )
      : null
    !state.quoteInfo.insured.address
      ? Vue.set(
          state.quoteInfo.insured,
          'address',
          policyAndInvtype.deliveryInfo.address
        )
      : null
    // 保单样式
    // Vue.set(state.quoteInfo.base.busiAttrConfig, 'policyStyles', policyAndInvtype.policyStyles);
  },
  // 保存天津新车车船税信息
  setTjNewVhlTax(state, tjNewVhlTax) {
    // 保存车船税
    state.quoteInfo.riskList.forEach((risk, index) => {
      if (CONSTANTS.JQ_RISK_CODE == risk.riskCode) {
        let newTaxReliefInfo = Object.assign(
          {},
          risk.vhlTax,
          tjNewVhlTax.vhlTax
        )
        Vue.set(state.quoteInfo.riskList[index], 'vhlTax', newTaxReliefInfo)
      }
    })
    // 车辆落户地址
    Vue.set(
      state.quoteInfo.vehicle,
      'settleAddressCode',
      tjNewVhlTax.settleAddressCode
    )
  },
  setTempNo(state, tempNo) {
    Vue.set(state, 'tempNo', tempNo)
  },
  /*  setTempNoRelatedFrameNo(state,tempNo){
    let json ={};
    json[state.quoteInfo.vehicle.frameNo] = tempNo;
    Vue.set(state, 'tempNoRelatedFrameNo', json);
  } */
  setApplicantEmail(state, email) {
    Vue.set(state.quoteInfo.applicant, 'email', email)
  },
  setHoliday(state, holidayInfo) {
    Vue.set(state, 'holidayInfo', holidayInfo);
  }
}

const actions = {
  copy({ commit }, options) {
    return $http.copy(options).then((res) => {
      let quoteInfo = res.result
      commit('setQuoteInfo', quoteInfo)
      return quoteInfo
    })
  },
  // 获取上年报价方案 和 转保方案
  queryCoverQuote({ commit, rootState, state }) {
    return $http
      .queryCoverQuote({
        query: { flowId: rootState.flowId },
        showLoading: false,
        closeLoading: false,
        /* data: {
        vhlTaxReqVO: state.vhlTax
      }, */
        data: state.vhlTax,
      })
      .then((res) => {
        if (res.resultCode == 0) {
          let riskList = res.result
          let sy_code =
            state.switchList.new_energy_vehicles_switch == '1' &&
            state.quoteInfo.vehicle.newEnergyFlag == '1' &&
            state.quoteInfo.base.insuredProduct == '3'
              ? CONSTANTS.XNY_RISK_CODE
              : CONSTANTS.SY_RISK_CODE
          commit('setRiskList', riskList)
          //   flag为0为转保数据, 需要重设商业险默认保额
          if (
            ((riskList.length == 1 && riskList[0].riskCode == sy_code) ||
              riskList.length == '2') &&
            riskList[0].flag == '0'
          ) {
            commit('setSyRiskListDefauleInsured', riskList)
          }
          return riskList
        } else {
          let errMsg = res.errorMsg || '续转保数据获取失败!'
          return Promise.reject(errMsg)
        }
      })
  },
  // 折旧
  depreciation({ commit, getters, rootState }, startDate) {
    let sy_code =
      state.switchList.new_energy_vehicles_switch == '1' &&
      state.quoteInfo.vehicle.newEnergyFlag == '1' &&
      state.quoteInfo.base.insuredProduct == '3'
        ? CONSTANTS.XNY_RISK_CODE
        : CONSTANTS.SY_RISK_CODE
    // 折旧入参
    let depreciationData = {
      riskCode: sy_code,
      // 230418,修复bug。单交强险报价成功，返回车型页，再点击报价时getters.getSyRisk为undefined的bug
      startDate: startDate || (getters.getSyRisk ? getters.getSyRisk.startDate : utils.recNexDate()),
    }
    // if (sy_code == '0317') {
    //   // TODO 折旧计算接口,新能源产品下必传modelCode
    //   depreciationData['modelCode'] = state.quoteInfo.vehicle.modelCode || '';
    // }

    return $http
      .officialDepreciation({
        query: { flowId: rootState.flowId },
        data: depreciationData,
        showLoading: false,
        closeLoading: false,
      })
      .then((res) => {
        if (res.resultCode == 0) {
          commit('setDepreciation', res.result)
          return res.result.actualValue
        } else {
          let errMsg = res.errorMsg || '折旧失败!'
          return Promise.reject(errMsg)
        }
      })
  },
  // 地方税务机关查询
  queryVhlTaxRelief({ commit, state }) {
    let taxReliefInfo = {
      identifyNumber: state.quoteInfo.owner.identifyNumber,
      taxpayerIdentifier: state.quoteInfo.owner.identifyNumber,
      certiType: state.quoteInfo.owner.identifyType || '01',
      relifReason: '7',
      // fuelType: '0',
      fuelType: state.quoteInfo.vehicle.powerTypeCode || '0',
    }
    let fuelFlag = state.quoteInfo.vehicle.fuelFlag || '0'

    // 税务机关查询入参
    let queryVhlTaxReliefData = {
      brandName: state.quoteInfo.vehicle.brandName,
      companyCode: state.quoteInfo.base.companyCode,
      fuelFlag: fuelFlag,
      seatCount: state.quoteInfo.vehicle.seatCount,
    }

    //处理减免标志
    if (fuelFlag == '0') {
      // 缴税
      taxReliefInfo = Object.assign({}, taxReliefInfo, {
        taxRelifFlag: '02',
        taxCompancyCode: '',
        taxCompancyName: '',
        paidFreeCertificate: '',
        deductionDueType: '',
      })
      return new Promise((resolve) => {
        commit('setTaxRelief', taxReliefInfo)
        resolve(true)
      })
    } else if (fuelFlag == '1' || fuelFlag == '3') {
      /*
        免税
        deductionDueType: 默认"E" 免税
      */
      taxReliefInfo = Object.assign({}, taxReliefInfo, {
        taxRelifFlag: '05',
      })
      return $http
        .queryVhlTaxRelief({
          data: queryVhlTaxReliefData,
          showLoading: false,
          closeLoading: false,
        })
        .then((res) => {
          if (res.resultCode == 0) {
            taxReliefInfo = Object.assign({}, taxReliefInfo, {
              taxCompancyCode: res.taxCompancyCode,
              taxCompancyName: res.taxCompancyName,
              paidFreeCertificate: res.paidFreeCertificate,
              deductionDueType: 'E',
            })
            commit('setTaxRelief', taxReliefInfo)
            return true
          } else {
            let errMsg = res.errorMsg || '税务机关查询失败!'
            return Promise.reject(errMsg)
          }
        })
    } else if (fuelFlag == '2' || fuelFlag == '4') {
      /* 
        减税:
        deductionDueType: 默认"P" 比例减免
        freeRate: 默认50%
      */
      taxReliefInfo = Object.assign({}, taxReliefInfo, {
        taxRelifFlag: '04',
      })
      return $http
        .queryVhlTaxRelief({
          data: queryVhlTaxReliefData,
          showLoading: false,
          closeLoading: false,
        })
        .then((res) => {
          if (res.resultCode == 0) {
            taxReliefInfo = Object.assign({}, taxReliefInfo, {
              taxCompancyCode: res.taxCompancyCode,
              taxCompancyName: res.taxCompancyName,
              paidFreeCertificate: res.paidFreeCertificate,
              deductionDueType: 'P',
              freeRate: 50,
            })
            commit('setTaxRelief', taxReliefInfo)
            return true
          } else {
            let errMsg = res.errorMsg || '税务机关查询失败!'
            return Promise.reject(errMsg)
          }
        })
    }
  },
  // 保存流数据
  officialApply({ state, rootState, commit }, options) {
    // state.quoteInfo.vehicle.licenseColorCode = '01'
    // state.quoteInfo.vehicle.licenseTypeCode = '02' // 测试用
    let data = {
      query: { flowId: rootState.flowId },
      data: state.quoteInfo,
      showLoading: false,
      closeLoading: false,
    }
    options = options || {}
    data = Object.assign({}, data, options)
    if (!data.data.beijing) {
      data.data.vehicle.certificateType = ''
    }
    let jqRisk = data.data.riskList.filter((item) => {
      return item.riskCode === '0301'
    })[0]
    if (data.data.shanghai && data.data.riskList && jqRisk) {
      jqRisk.vhlTax.relifReason = ''
      jqRisk.vhlTax.taxItemDetailCode = ''
    }
    if (window.recordSwitch) {
      data.data.taskId = rootState.flowId // 用于视频录制
    }
    return $http.officialApply(data).then((res) => {
      if (res.resultCode == '0') {
        let tempNo = res.result
        let tempNoJson = {}
        let liscenseNo = state.quoteInfo.vehicle.licenseNo
        let frameNo = state.quoteInfo.vehicle.frameNo
        //commit('setTempNoRelatedFrameNo', tempNo);
        if (liscenseNo && liscenseNo != '*-*') {
          tempNoJson[liscenseNo] = tempNo
          commit('setTempNo', tempNo)
        } else if (frameNo) {
          tempNoJson[frameNo] = tempNo
        }
        window.localStorage.setItem('tempNoInfo', JSON.stringify(tempNoJson))
        window.localStorage.setItem('Source', 'XZB')
        return res.result
      } else {
        return Promise.reject(res.errorMsg)
      }
    })
  },
  // 提核前数据交互
  supplement({ state, rootState, getters }) {
    let data = {
      insured: state.quoteInfo.insured,
      applicant: state.quoteInfo.applicant,
      vehicle: state.quoteInfo.vehicle,
      clauseList: getters.getClauseList,
      frmNoFlag: null,
    }
    return $http
      .supplement({
        query: { flowId: rootState.flowId },
        data,
      })
      .then((res) => {
        if (res.resultCode == '0') {
          return res.result
        } else {
          return Promise.reject(res.errorMsg)
        }
      })
  },
  // 请求支付参数
  payment({ state }, getPaymentInfo) {
    return $get.payment({
      query: getPaymentInfo,
    })
  },
  // 请求节假日数据
  queryHolidayInfo({ state, commit }, date) {
    return $get.queryHolidayInfo({
      query: {
        date: date
      }
    }).then((res) => {
      if (res.resultCode === '0' && res.result && res.result.holidayflag==='0') {
        commit('setHoliday', res.result);
        return true;
      } else {
        commit('setHoliday', res.result);
        return false;
      }
    }).catch(err => {
      commit('setHoliday', null);
      return false;
    })
  },
  // 查询报价前弹框提示内容
  async queryPopFrameInfo({ commit }, companyCode) {
    try {
      const res = await $get.queryPopFrameInfo({
        query: {
          companyCode
        }
      })
      commit('setPopFrameInfo', res.result)
    } catch (error) {
      commit('setPopFrameInfo', null)
      console.log(error);
    }
  },
  // 记录验车埋点接口
  getVehicleInspectionRecord({ state }) {
    return $http.vehicleInspectionRecord({
      data: {
				frmNo: state.quoteInfo.vehicle.frameNo,
				operatorCode: state.quoteInfo.base.operatorCode,
				operatorName: state.quoteInfo.base.operatorName,
				terminalSource: state.quoteInfo.base.terminalSource,
		  }
    })
  },
  // 获取验车短链
  getVehicleInspectionGetShortLinks({ state, commit, getters }) {
    const syRisk =  getters.getSyRisk;
    let tempNoInfo = JSON.parse(localStorage.getItem('tempNoInfo')) || {};
    let tempNo = tempNoInfo[state.quoteInfo.vehicle.licenseNo] || tempNoInfo[state.quoteInfo.vehicle.frameNo];
    return $http.vehicleInspectionGetShortLinks({
      data: {
				operateType: syRisk.proposalNo ? 'P' : 'Q', // 操作环节， 报价环节- ‘Q’投保环节- ‘P’， 批改环境- ‘E’
				businessNo: syRisk.proposalNo || syRisk.quotationNo || '', // 业务单号，可传报单价号、投保单号、批改申请单号；关联出单请用“，”号隔开
				imageId: syRisk.imageId || '', // 影像ID
				riskCode: syRisk.riskCode || '', // 险种代码
				operatorCode: state.quoteInfo.base.operatorCode || '', // 发起人/操作人
				operatorName: state.quoteInfo.base.operatorName || '', // 操作人名称
				receiveType: '1', // 接收对象类型，投保人-“1”，业务员-“2”
				name: state.quoteInfo.applicant.name || '', // 接收人名称
				mobilePhone: state.quoteInfo.applicant.phone || '', // 接收人手机号码
				terminalSource: state.quoteInfo.base.terminalSource || '',
				smsType: '2', // 通知类型 1-短信 2-短链 （为空默认短信）
				tempNo: tempNo || '',
				quotationNo: syRisk.quotationNo || '',
				applyPolicyNo: syRisk.proposalNo || '',
				frmNo: state.quoteInfo.vehicle.frameNo || '',
				vhlNo: state.quoteInfo.vehicle.licenseNo || ''
		  }
    }).then((res) => {
      if (res.resultCode == '0') {
        return res.result
      } else {
        return Promise.reject(res.errorMsg)
      }
    })
  }
}

const state = {
  vhlTax: null,
  tempNo: '',
  tempNoRelatedFrameNo: {},
  riskFlag: {
    jqFlag: false,
    syFlag: false,
  },
  cacheRecordInfo: {
    owner: {
      name: '',
      identifyNumber: '',
      identifyExpiry: '',
      birthday: '',
      justSrc: '',
      justName: '',
      backName: '',
      backSrc: ''
    },
    insured: {
      name: '',
      identifyNumber: '',
      identifyExpiry: '',
      birthday: '',
      justSrc: '',
      justName: '',
      backName: '',
      backSrc: ''
    },
    applicant: {
      name: '',
      identifyNumber: '',
      identifyExpiry: '',
      birthday: '',
      justSrc: '',
      justName: '',
      backName: '',
      backSrc: ''
    },
    vehicle: {
      licenseNo: '',
      brandName: '',
      frameNo: '',
      singeinDate: '',
      engineNo: '',
      justSrc: '',
      justName: '',
      backName: '',
      backSrc: ''
    },
  },
  calPremiumResult: {},
  agentInfo: {},
  switchList: {},
  isDigital: 2, // 机构是否开通数电发票, 0: 接口调取失败，需要清除发票字段且清除选项；1：机构开通数电；2：机构未开通数电
  cityInfo: {}, //isBeijing:true, isXiamen:false....
  quoteInfo: utils.deepClone(CONSTANTS.CAR_BEANS),
  // 这里专门保存流程初始化时返回的Basebean信息, 以防有些配置只能取初始化时的值,不能改成后续返回的,
  // 比如电子保单可选项 ==> 只作为可选项option_list的提供源
  initQuoteInfo: utils.deepClone(CONSTANTS.CAR_BEANS),
  electronicPolicyFlag: false, // 华安电子保单标志
  lastQuoteInfo: utils.deepClone(EMPTY_QUOTEINFO),
  baseAddress: '',
  address: [],
  // 商业险  无赔优待系数
  holidayInfo: null,
  popFrameInfo: null,
  sdQuoteInfo: utils.deepClone(CONSTANTS.CAR_BEANS),
  useNaturesSubSwitch: false // 二季度使用性质开关
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
